import { createSlice } from '@reduxjs/toolkit';


const initialValues = {
  custNum: null,
  vendorShortKey: [],
  commissionName: "",
  abNumber: "",
  orderStatus: "",
  // plannedLoadingYear: currentYear,
  // month: "",
  plannedLoadingWeek: "",
  orderType: "",
  documentNum: "", //documentNum
  orderCategory: [],
  categoryGroup: null,
  territory: [],
  region: [],
  showroomNum: [],
  mainPriceGrp: [],
  mainRange: [],
  mainColour: [],
  mainCarcass: [],
  mainHandle: [],
  intlContainerNum: "",
  actualContainerNum: "",
  listPort: [],
  freightId: [],
  tourNo: "",
  pdrStatus: "",
  pdpStatus: "",
  sdrStatus: [],
  sdpStatus: [],
  psdStatus: [],
  orderStatus2: null,
  createdDtFrom: null,
  createdDtTo: null,
  plannedLoadingDateFrom: null,
  plannedLoadingDateTo: null,
  actualLoadingDateFrom: null,
  actualLoadingDateTo: null,
  orderPlacedDateFrom: null,
  orderPlacedDateTo: null,
  abReceivedDateFrom: null,
  abReceivedDateTo: null,
  orderConfirmedDateFrom: null,
  orderConfirmedDateTo: null,
  fromDate: null,
  toDate: null,
  // pageNo: 0,
  // pageSize: 20,
};

const filterSlice = createSlice({
  name: 'filter',
  initialState: {
    filter: initialValues,
    hasFilter:false,
    cardStatus:"",
  },
  reducers: {
    setSavedFilter: (state, action) => {
      state.filter = action.payload;
    },
  
    setHasFilter:(state,action)=>{
      state.hasFilter=action.payload;

    },
    
  setSavedFilterCardStatus: (state, action) => {
      state.cardStatus = action.payload;
      state.filter.orderStatus2 = action.payload;
    },
    clearFilter: (state) => {
      state.hasFilter=false;
      state.filter = initialValues;
      state.cardStatus="";
    },
  },
});

export const { setSavedFilter,setHasFilter,clearFilter,setSavedFilterCardStatus} = filterSlice.actions;
export default filterSlice.reducer;
